import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedMethodsSection } from './components/FailedMethodsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialSection } from './components/TestimonialSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (!f.fbq) {
      const n: any = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
    f.fbq('init', '1620136315977575');
    f.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full flex flex-col overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedMethodsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <TestimonialSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}